export default __webpack_public_path__ + "static/media/024-inflatable space habitat.e12e9fa2.svg";